/**
 * Package Name: jcfs-2023.js
 * Subpackage: jcfs
 * Author: Raven Developers
 * Author URI: https://www.ravendevelopers.com
 * Description: Javascript
 * Author: anithegregorian
 * Created: 03/05/23
 * Version: 1.0
 * License: Creative Commons 3.0 Attribution
 * License URI: https://creativecommons.org/licenses/by/3.0/us/
 * Tags: app
 **/
import '../../../ypbbs/vendor/bootstrap/js/src/util';
import '../../../ypbbs/vendor/bootstrap/js/src/modal';
import '../../../ypbbs/vendor/bootstrap/js/src/popover';
import '../../../ypbbs/vendor/bootstrap/js/src/tooltip';
import '../../../ypbbs/vendor/bootstrap/js/src/collapse';

(function (jcfs, undefined) {
  'use strict';

  jcfs.mediaQuerySize = () => {
    try {
      if (matchMedia('(max-width: 767.98px)').matches) {
        return 'sm';
      } else if (matchMedia('(max-width: 991.98px)').matches) {
        return 'md';
      } else if (matchMedia('(min-width: 992px)').matches) {
        return 'lg';
      }
    } finally {
    }
  };

})(window.jcfs = window.jcfs || {});

(function ($, Drupal) {

  'use strict';

  /**
   * Behavior description.
   */
  Drupal.behaviors.jcfs2023 = {
    attach: function (context, settings) {

      var ex = new EX({ offset: 100 }).init();

      $(document).ready(function () {
        const mediaSize = jcfs.mediaQuerySize();

        if (navigator.userAgent.indexOf('Mac') > 0) {
          $('body').addClass('mac-os');
        }

        // read more read less functionality
        $('.see-more-less-wrap .more').click(function () {
          $(this).parents('.see-more-less-wrap').find('.more').hide();
          $(this).parents('.see-more-less-wrap').find('.less').show();
          $(this)
            .parents('.see-more-less-wrap')
            .find('.more-less-content')
            .slideDown();
        });
        $('.see-more-less-wrap .less').click(function () {
          $(this).parents('.see-more-less-wrap').find('.more').show();
          $(this).parents('.see-more-less-wrap').find('.less').hide();
          $(this)
            .parents('.see-more-less-wrap')
            .find('.more-less-content')
            .slideUp();
        });

        // Handle click event for Header Search
        $('#site-header #header-search').click(function (event) {
          event.preventDefault();
          Drupal.behaviors.headerModal.modal();
          return false;
        });

        // Popover
        if (mediaSize === 'md' || mediaSize === 'sm') {
          $('[data-toggle="popover"]').popover({
            container: 'body',
            boundary: 'viewport',
            placement: 'bottom',
            trigger: 'focus',
          });

          // Get all the fieldsets with the class "fieldgroup"
          const fieldsets = document.querySelectorAll('#views-exposed-form-event-calendar-page-week fieldset.fieldgroup');

          if (fieldsets) {
            // Loop through each fieldset
            fieldsets.forEach((fieldset) => {
              // Get the legend element inside the fieldset
              const legend = fieldset.querySelector('legend');

              // Initial state collapsed for all fieldsets
              fieldset.classList.add('collapsed');

              // Add a click event listener to the legend
              legend.addEventListener('click', () => {
                // Toggle the "collapsed" class on the fieldset
                fieldset.classList.toggle('collapsed');

                if (!fieldset.classList.contains('collapsed')) {
                  fieldset.scrollIntoView({
                    behavior: 'smooth',
                  });
                }

              });
            });
          }

        } else {
          $('[data-toggle="popover"]').popover({
            container: 'body',
            boundary: 'viewport',
            placement: 'right',
            trigger: 'focus',
          });
        }

        $('.wrapper-mobile-nav #sidr ul.menu .menu-item--expanded').each(function () {
          const siblingItem = $(this?.firstElementChild?.lastElementChild);
          const goBackItem = $(this?.children).find('.menu-level-header > a');

          $(siblingItem).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            const $this = $(this);
            $this.parent().parent().siblings().hide();
            $this.parent().hide();
            // Show the submenu
            $this.parent().siblings('ul').show('slide');
          });

          $(goBackItem).on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            const $currentMenu = $(this).parent().parent();
            const $prevMenu = $currentMenu.parent();
            const $parentLink = $currentMenu.siblings('.link-title');

            console.log($currentMenu, $prevMenu, $parentLink);

            $currentMenu.hide('slide');

            if ($parentLink.css('display') === 'none') {
              $parentLink.show('fast');
            }
            $prevMenu.siblings().show('fast');
          });

        });

        // If pre footer is available then add class to body
        if ($('.pre-footer-wrap').length) {
          $('body').addClass('has-pre-footer');
        }

      });

      //
      const quickViewButtons = document.querySelectorAll('[data-quick-view]');
      const closeButtons = document.querySelectorAll('[data-close]');
      const fullwidthCards = document.querySelectorAll('.fullwidth');
      let toggle; // Quick view <button>.
      let toggleParent; // <li>.
      let fullwidth; // Fullwidth card to be "injected".

      const openQuickView = (toggle, toggleParent, fullwidth) => {
        toggle.setAttribute('aria-expanded', 'true');
        toggleParent.classList.toggle('is-selected');
        fullwidth.classList.toggle('is-hidden');
        // Make fullwidth card keyboard focusable.
        fullwidth.setAttribute('tabIndex', '0');
      };

      const closeQuickView = (toggle, toggleParent, fullwidth) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggleParent.classList.toggle('is-selected');
        fullwidth.classList.toggle('is-hidden');
        fullwidth.removeAttribute('tabIndex');
      };

      quickViewButtons.forEach(quickView => {
        // Add appropriate ARIA attributes for "toggle" behaviour.
        fullwidth = quickView.parentElement.nextElementSibling;
        quickView.setAttribute('aria-expanded', 'false');
        quickView.setAttribute('aria-controls', fullwidth.id);

        quickView.addEventListener('click', (e) => {
          toggle = e.target;
          toggleParent = toggle.parentElement;
          fullwidth = toggleParent.nextElementSibling;

          // Open (or close) fullwidth card.
          if (toggle.getAttribute('aria-expanded') === 'false') {
            // Do we have another fullwidth card already open? If so, close it.
            fullwidthCards.forEach(fullwidthOpen => {
              if (!fullwidthOpen.classList.contains('is-hidden')) {
                toggleParentOpen =
                  fullwidthOpen.previousElementSibling;
                toggleOpen = toggleParentOpen.querySelector(
                  '[data-quick-view]',
                );

                closeQuickView(toggleOpen, toggleParentOpen, fullwidthOpen);
              }
            });

            openQuickView(toggle, toggleParent, fullwidth);
            fullwidth.scrollIntoView({
              behavior: 'smooth'
            });
          } else {
            closeQuickView(toggle, toggleParent, fullwidth);
          }
        });
      });

      closeButtons.forEach(close => {
        close.addEventListener('click', (e) => {
          fullwidth = e.target.parentElement;
          toggleParent = e.target.parentElement.previousElementSibling;
          toggle = toggleParent.querySelector('[data-quick-view]');

          closeQuickView(toggle, toggleParent, fullwidth);
          toggle.focus(); // Return keyboard focus to "toggle" button.
        });
      });

    },
  };

}(jQuery, Drupal));
